// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"b3a22e16","744":"1d5bba29"}[chunkId] + ".chunk.css";
};